<template>
  <section class="task-wrap" :style="dBHeight">
    <!-- <modals-container @updateRole="getUserList" @registRole="getUserList"></modals-container> -->
    <div class="tab_ty1">
      <AuditTab :currentTab="0" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="0" :currentTab2="2" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit003">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-if="uploadStatus && !downloadStatus && !dormantExceptYn"> <!-- 외부망업로드허용 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(1,0,0)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(1,0,0)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>

                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else-if="downloadStatus && !uploadStatus && !dormantExceptYn"> <!-- 외부망다운로드허용 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(0,1,0)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(0,1,0)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>

                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else-if="!downloadStatus && !uploadStatus  && dormantExceptYn && tenantId =='201'"> <!-- 휴면계정예외자여부 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(0,0,1)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(0,0,1)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>  
                    
                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else-if="!downloadStatus && uploadStatus  && dormantExceptYn && tenantId =='201'"> <!-- 업로드여부/휴면계정예외자여부 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(0,1,1)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(0,1,1)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>

                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else-if="downloadStatus && !uploadStatus  && dormantExceptYn && tenantId =='201'"> <!-- 다운로드여부/휴면계정예외자여부 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(1,0,1)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(1,0,1)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>


                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else-if="uploadStatus && downloadStatus && dormantExceptYn"> <!-- 모두 체크  -->
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(1,1,1)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(1,1,1)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>

                    <div class="search_ty2" style="float: right;padding-right: 20px;" v-else>
                      <input
                        type="text"
                        required
                        :placeholder="$i18nUtil.trans('message.UserList.001','사용자명/아이디 검색')"
                        v-model="searchUser"
                        @keyup.enter="[changePage(), getUserList(0,0,0)]"
                      />
                      <button
                        type="button"
                        class="input-txt"
                        @click="[changePage(), getUserList(0,0,0)]"
                      >{{$i18nUtil.trans("search.039","검색")}}
                      </button>
                    </div>

                    <div class="tb_sort fr">
                      <input type="checkbox" id="upload" v-model="uploadStatus" @change="checkUserList">
                        <label for="upload">{{$i18nUtil.trans("message.UserList.003","외부망업로드허용")}}</label>
                      <input type="checkbox" id="download" v-model="downloadStatus" @change="checkUserList">
                      <label v-if="tenantId =='201'" for="download" >{{$i18nUtil.trans("message.UserList.004","외부망다운로드허용")}}</label>
                        <label v-else for="download" style="margin-right: 20px;">{{$i18nUtil.trans("message.UserList.004","외부망다운로드허용")}}</label>
                      <input v-if="tenantId =='201'" type="checkbox" id="dormantExcept" v-model="dormantExceptYn" @change="checkUserList">
                        <label v-if="tenantId =='201'" for="dormantExcept" style="margin-right: 20px;">{{$i18nUtil.trans("message.UserList.013","휴면계정예외자여부")}}</label>
                    </div>
                  </div>

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="userList"
                    hide-default-footer
                    class="tb-contents"
                    v-bind:style="[tenantId =='201'? dormantCss:'']"
                  >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{ item.userName }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{ item.userId }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{ item.deptName }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{ item.deptId }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{ item.jobPositionName }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block">
                            {{
                              $moment(item.lastLoginDate).format(
                                "YYYY.MM.DD HH:mm"
                              )
                            }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="updateExternalYn(item, 'upload')">
                            {{ item.externalUploadYn == 1 ? $i18nUtil.trans('message.UserList.005','허용') : $i18nUtil.trans('message.UserList.006','불가') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="updateExternalYn(item, 'download')">
                            {{ item.externalDownloadYn == 1 ? $i18nUtil.trans('message.UserList.005','허용') : $i18nUtil.trans('message.UserList.006','불가') }}
                          </span>
                        </div>
                      </td>
                      <td v-if="tenantId =='201'">
                        <div>
                          <span class="ell-singleline d-block cursor-pointer" @click="updateExternalYn(item, 'dormantExcept')">
                            {{ item.dormantExceptYn == 1 ? $i18nUtil.trans('message.UserList.005','허용') : $i18nUtil.trans('message.UserList.006','불가') }}
                          </span>
                        </div>
                      </td>                      
                    </tr>
                  </template>

                  <template slot="no-data">
                    <div class="nodata-txt-noicon">
                      <v-alert :value="true">
                        {{$i18nUtil.trans("message.UserList.002","사용자 리스트가 없습니다.")}}
                      </v-alert>
                    </div>
                  </template>
                  </v-data-table>

                  <div v-if="pageCount > 0 && uploadStatus && !downloadStatus && !dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(1,0,0)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && downloadStatus && !uploadStatus && !dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(0,1,0)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && !uploadStatus && !downloadStatus && dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(0,0,1)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && !uploadStatus && downloadStatus && dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(0,1,1)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && uploadStatus && !downloadStatus && dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(1,0,1)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && uploadStatus && downloadStatus && !dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(1,1,0)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && uploadStatus && downloadStatus && dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(1,1,1)"
                    ></v-pagination>
                  </div>
                  <div v-else-if="pageCount > 0 && !uploadStatus && !downloadStatus && !dormantExceptYn" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getUserList(0,0,0)"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";

export default {
  components: {
    AuditSubTab,
    AuditTab,
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      dormantCss: {
        "width": 1300 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      userList: [],
      searchUser: "",
      uploadStatus: false,
      downloadStatus: false,
      dormantExceptYn: false,
      headers: [
        { text: this.$i18nUtil.trans("message.RoleUserRegist.001","사용자명"), value: "userName", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.userId","아이디"), value: "userId", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.deptName.002","부서명"), value: "deptName", sortable: false },
        { text: this.$i18nUtil.trans("message.UserList.007","부서아이디"), value: "deptId", sortable: false },
        { text: "Position", value: "jobPositionName", sortable: false },
        { text: this.$i18nUtil.trans("message.UserList.008","최근로그인일시"), value: "lastLoginDate", sortable: false },
        { text: this.$i18nUtil.trans("message.UserList.003","외부망업로드허용"), value: "externalUploadYn", sortable: false },
        { text: this.$i18nUtil.trans("message.UserList.004","외부망다운로드허용"), value: "externalDownloadYn", sortable: false },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    this.checkUserList();
    if(this.tenantId == 201) {
    this.headers.push({ text: this.$i18nUtil.trans("message.UserList.013","휴면계정예외자여부"), value: "dormantExceptYn", sortable: false }  )
}
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    /* 사용자 리스트 조회 */
    checkUserList(){
      let obj = this;
      if(!obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){
        obj.getUserList(0,0,0);
      } else if(obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용 체크
        obj.getUserList(1,0,0);
      } else if(!obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망다운드허용 체크
        obj.getUserList(0,1,0);
      } else if(!obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 휴면계정예외자여부 체크
        obj.getUserList(0,0,1);
      } else if(obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 외부망업로드허용/휴면계정예외자여부 체크
        obj.getUserList(1,0,1);
      } else if(!obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 외부망다운드허용/휴면계정예외자여부 체크
        obj.getUserList(0,1,1);
      } else if(obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용/외부망다운드허용
        obj.getUserList(1,1,0);
      } else if(obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 모두 체크
        obj.getUserList(1,1,1);
      }
    },
    
    getUserList(upload, download, dormantExcept) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        searchUser: obj.searchUser,
        uploadYn: upload,
        downloadYn: download,
        dormantExceptYn: dormantExcept,
      };
      reqData.url = "/api/org/user/getUserList";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.userList = res.result.userList;
            obj.totalCount = res.result.userCount;
            obj.pageCount = res.result.userPageCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    updateExternalYn(item, update) {
      if(update == 'upload'){
        if (confirm(this.$i18nUtil.trans("message.UserList.009","외부망업로드허용 상태를 변경하시겠습니까?"))) {
          let uploadYn = 1;
          if(item.externalUploadYn == 1){
            uploadYn = 0;
          }
          let obj = this;
          let reqData = {};
          reqData.params = {
            userId: item.userId,
            update: 'upload',
            updateYn: uploadYn,
          };
          reqData.url = "/api/auth/org/updateExternalYn";
          reqData.method = "post";
          //프로그레스바 시작
          this.showLoadingbar();
          obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              if (res.errorCode) {
                console.log(res.errorCode);
              } else {
                obj.toastInfo.message = this.$i18nUtil.trans("message.UserList.010","외부망업로드허용 상태가 변경되었습니다.");
                obj.showToast(obj.toastInfo);
               if(!obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){
                obj.getUserList(0,0,0);
              } else if(obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용 체크
                obj.getUserList(1,0,0);
              } else if(!obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망다운드허용 체크
                obj.getUserList(0,1,0);
              } else if(!obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 휴면계정예외자여부 체크
                obj.getUserList(0,0,1);
              } else if(obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 외부망업로드허용/휴면계정예외자여부 체크
                obj.getUserList(1,0,1);
              } else if(!obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 외부망다운드허용/휴면계정예외자여부 체크
                obj.getUserList(0,1,1);
              } else if(obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용/외부망다운드허용
                obj.getUserList(1,1,0);
              } else if(obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 모두 체크
                obj.getUserList(1,1,1);
              }
              }
            })
            .catch((err) => {
              console.log("axios err => ", err);
            });
        }
      } else if(update == 'download'){
        if (confirm(this.$i18nUtil.trans("message.UserList.011","외부망다운로드허용 상태를 변경하시겠습니까?"))) {
          let downloadYn = 1;
          if(item.externalDownloadYn == 1){
            downloadYn = 0;
          }
          let obj = this;
          let reqData = {};
          reqData.params = {
            userId: item.userId,
            update: 'download',
            updateYn: downloadYn,
          };
          reqData.url = "/api/auth/org/updateExternalYn";
          reqData.method = "post";
          //프로그레스바 시작
          this.showLoadingbar();
          obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              if (res.errorCode) {
                console.log(res.errorCode);
              } else {
                obj.toastInfo.message = this.$i18nUtil.trans("message.UserList.012","외부망다운로드허용 상태가 변경되었습니다.")
                obj.showToast(obj.toastInfo);
                if(!obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){
                  obj.getUserList(0,0,0);
                } else if(obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용 체크
                  obj.getUserList(1,0,0);
                } else if(!obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망다운드허용 체크
                  obj.getUserList(0,1,0);
                } else if(!obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 휴면계정예외자여부 체크
                  obj.getUserList(0,0,1);
                } else if(obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 외부망업로드허용/휴면계정예외자여부 체크
                  obj.getUserList(1,0,1);
                } else if(!obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 외부망다운드허용/휴면계정예외자여부 체크
                  obj.getUserList(0,1,1);
                } else if(obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용/외부망다운드허용
                  obj.getUserList(1,1,0);
                } else if(obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 모두 체크
                  obj.getUserList(1,1,1);
                }
              }
            })
            .catch((err) => {
              console.log("axios err => ", err);
            });
        }
      } else{
        if (confirm(this.$i18nUtil.trans("message.UserList.014","휴면계정예외자여부 상태를 변경하시겠습니까?"))) {
          let dormantExceptYn = 1;
          if(item.dormantExceptYn == 1){
            dormantExceptYn = 0;
          }
          let obj = this;
          let reqData = {};
          reqData.params = {
            userId: item.userId,
            update: 'dormantExceptY',
            updateYn: dormantExceptYn,
          };
          reqData.url = "/api/auth/org/updateExternalYn";
          reqData.method = "post";
          //프로그레스바 시작
          this.showLoadingbar();
          obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              if (res.errorCode) {
                console.log(res.errorCode);
              } else {
                obj.toastInfo.message = this.$i18nUtil.trans("message.UserList.015","휴면계정예외자여부 상태가 변경되었습니다.")
                obj.showToast(obj.toastInfo);
              if(!obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){
                obj.getUserList(0,0,0);
              } else if(obj.uploadStatus && !obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용 체크
                obj.getUserList(1,0,0);
              } else if(!obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망다운드허용 체크
                obj.getUserList(0,1,0);
              } else if(!obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 휴면계정예외자여부 체크
                obj.getUserList(0,0,1);
              } else if(obj.uploadStatus && !obj.downloadStatus && obj.dormantExceptYn){ // 외부망업로드허용/휴면계정예외자여부 체크
                obj.getUserList(1,0,1);
              } else if(!obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 외부망다운드허용/휴면계정예외자여부 체크
                obj.getUserList(0,1,1);
              } else if(obj.uploadStatus && obj.downloadStatus && !obj.dormantExceptYn){ // 외부망업로드허용/외부망다운드허용
                obj.getUserList(1,1,0);
              } else if(obj.uploadStatus && obj.downloadStatus && obj.dormantExceptYn){ // 모두 체크
                obj.getUserList(1,1,1);
              }
              }
            })
            .catch((err) => {
              console.log("axios err => ", err);
            });
        }
      }
    },
    changePage() {
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.audit003 {
  margin-top: 38px;
  width: max-content;
}
.audit003 >>> th:nth-child(1),
.audit003 >>> td:nth-child(1) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(2),
.audit003 >>> td:nth-child(2) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(3),
.audit003 >>> td:nth-child(3) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(4),
.audit003 >>> td:nth-child(4) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(5),
.audit003 >>> td:nth-child(5) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(6),
.audit003 >>> td:nth-child(6) {
  text-align: left;
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(7),
.audit003 >>> td:nth-child(7) {
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(8),
.audit003 >>> td:nth-child(8) {
  width: 147.38px !important;
}
.audit003 >>> th:nth-child(9),
.audit003 >>> td:nth-child(9) {
  width: 147.38px !important;
}

.audit003 >>> input {
  background-color: transparent;
}
.audit003 >>> th:nth-child(1) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(2) > span {
  margin-left: 10px;
}
.audit003 >>> th:nth-child(4) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(5) > span {
  margin-left: 35px;
}
.audit003 >>> th:nth-child(6) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(7) > span {
  margin-left: 30px;
}
.audit003 >>> th:nth-child(8) > span {
  margin-left: 10px;
}
.audit003 >>> th:nth-child(9) > span {
  margin-left: 10px;
}

.audit003 >>> td:nth-child(1) > div > span {
  text-align: left;
  margin-left: 30px;
  width: 117.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(2) > div > span {
  text-align: left;
  margin-left: 10px;
  width: 127.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(3) > div > span {
  text-align: left;  
  width: 147.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(4) > div > span {
  margin-left: 30px;
  width: 117.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(5) > div > span {  
  width: 117.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  text-align: center;
}
.audit003 >>> td:nth-child(6) > div > span {
  margin-left: 20px;
  width: 117.38px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.audit003 >>> td:nth-child(7) > div > span {
  width: 117.38px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin-left: 30px;
}
.audit003 >>> td:nth-child(8) > div > span {
  width: 117.38px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin-left: 20px;
}
.audit003 >>> td:nth-child(9) > div > span {
  width: 117.38px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin-left: 20px;
}
.audit003 >>> tbody::after {
  background: none;
}
.audit003 >>> tbody::before {
  background: none;
}

.pagination >>> button {
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/UserList.vue